//*************************************************************************************
//* WaMS Component Framework - app.vis.js
//* Version 0.2
//* Author: Damian Koch
//* Component framework visualization plugin
//* Requires d3, jQuery, WaMS Component Framework
//* 
//* This component utilizes d3 to render data visualizations to the page.
//* 
//* 04/11/18 DBK created
//* 05/10/18 DBK updated key to highlight matching elements on hover
//* 11/18/19 DBK added parameter1 setting support
//*************************************************************************************
app.Vis = (function () {
    var myVis = {
        Visualization: function () {
            this.handleUpdateSettings = function (e) {
                var target = $(e.target);
                var name = target.data('update-setting-type');
                var option = {};
                if (target.is("select")) {
                    option[name] = target.val();
                } else {
                    option[name] = target.data('update-setting-value');
                    $('[data-role="update-setting-click"][data-target="' + target.data('target') + '"][data-update-setting-type="' + target.data('update-setting-type') + '"]').removeClass('active');
                    target.addClass('active');
                }

                this.options = $.extend({}, this.options, option);

                if (name === "parameter1") {
                    this.updateDataSource(true, this.processingFunction);
                }

                this.update();
            };
            this.generatePath = function (path) {
                var p = this.options.sourceRelative ? app.page.appPath + path : path;
                if (this.options.parameter1Name !== "" && this.options.parameter1 !== "") {
                    if (p.indexOf("?") < 0) {
                        p = p + '?' + this.options.parameter1Name + '=' + this.options.parameter1;
                    }
                    else {
                        p = p + '&' + this.options.parameter1Name + '=' + this.options.parameter1;
                    }
                }
                return p;
            };
            this.updateDataSource = function (init, processingFunction) {
                var path = this.generatePath(this.options.sourcePath);
                var dataLoadFunction = this.options.sourceType === "json" ? d3.json : d3.csv;
                var renderFunction = init ? this.render.bind(this) : this.updateData.bind(this);

                if (init) {
                    $(this.options.visSelector).html("");
                    $(this.options.keySelector).html("");
                    $(this.options.keySelector2).html("");
                }

                if (this.options.groupedSourcePath && this.options.groupedSourcePath !== "") {
                    dataLoadFunction(this.generatePath(this.options.groupedSourcePath), this.setGroupedSource.bind(this));
                }

                if (processingFunction == null) {
                    dataLoadFunction(path).then(renderFunction);
                }
                else {
                    //processingFucntion = processingFunction.bind(this);
                    dataLoadFunction(path).then(processingFunction).then(renderFunction);
                }
            };
            this.update = function () {
                this.data = this.allData;
                this.updateScales();
                this.drawData();
            };
            this.updateData = function (data) {
                this.allData = data;
                this.update();
            };

            this.export = function () {
                this.baseVis._groups[0][0].setAttribute("xmlns", "http://www.w3.org/2000/svg");
                var svgData = this.baseVis._groups[0][0].outerHTML;
                var blobContent = [];

                blobContent.push('<?xml version="1.0" standalone="no"?>\r\n');
                blobContent.push(svgData);

                var svgBlob = new Blob(blobContent, { type: "image/svg+xml;charset=utf-8" });

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(svgBlob, this.options.name + ".svg");
                }
                else {
                    var svgUrl = URL.createObjectURL(svgBlob);
                    var downloadLink = document.createElement("a");
                    downloadLink.href = svgUrl;
                    downloadLink.download = this.options.name;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            };
            this.setGroupedSource = function (data) {
                this.groupedAllData = data;
            };

            $('[data-target~="' + this.options.name + '"][data-role~="update-setting-click"]').on('click', $.proxy(this.handleUpdateSettings, this));
            $('[data-target~="' + this.options.name + '"][data-role~="update-setting-change"]').on('change', $.proxy(this.handleUpdateSettings, this));
            $('[data-target~="' + this.options.name + '"][data-role~="export"]').on('click', $.proxy(this.export, this));

            this.data = null;
            this.allData = null;
            this.groupedAllData = null;
            this.groupedData = null;
            this.baseVis = null;
            this.body = null;
            this.dataSet = null;
            this.processingFunction = this.options.processingFunction;
            //original
            //this.color = d3.scaleOrdinal().range(["#525c72", "#21ce03", "#fe3302", "#fa46ff", "#876d0d", "#a24568", "#159bfc", "#14926d", "#9149f8", "#fd5a93", "#85706a", "#ad4d1e", "#4a8b00", "#a96bb1", "#04859b", "#4d6643", "#e2770f", "#4567c6", "#d517a9", "#76527b", "#c310f3", "#d5324b", "#7c78a9", "#657b79", "#7d80fd", "#949401", "#b46965", "#017065", "#6f864d", "#805432", "#12ad4b", "#b86dfd", "#b0743b", "#c66495", "#eb6555", "#5c5c59", "#0e7b3a", "#7b5057", "#5785b7", "#a14297", "#986782", "#884eaf"]);
            //theme1
            //this.color = d3.scaleOrdinal().range(["#A31D35", "#FABA27", "#F28D2C", "#ECDEAD", "#909191", "#516E7B", "#6A8F68", "#C2072E", "#DE6379", "#FFD679", "#FFBD7E", "#EC5374", "#C03951", "#FFCA50", "#FFA855", "#728892", "#8FAC8D", "#E1274F", "#84071D", "#D59606", "#CD6A0C", "#C8B677", "#747777", "#385967", "#4D744B", "#9E0022", "#5C0010", "#A87500", "#A24F00", "#A6924A", "#5A5F5F", "#224453", "#2E552C", "#78001A"]);
            //theme1 minus dark
            //this.color = d3.scaleOrdinal().range(["#FABA27", "#F28D2C", "#ECDEAD", "#909191", "#516E7B", "#6A8F68", "#DE6379", "#FFD679", "#FFBD7E", "#EC5374", "#C03951", "#FFCA50", "#FFA855", "#728892", "#8FAC8D", "#E1274F", "#84071D", "#D59606", "#CD6A0C", "#C8B677", "#747777", "#385967", "#4D744B", "#9E0022", "#5C0010", "#A87500", "#A24F00", "#A6924A", "#5A5F5F", "#224453", "#2E552C", "#78001A"]);
            //theme with blue
            this.color = d3.scaleOrdinal().range(["#178BCA", "#FABA27", "#6A8F68", "#F28D2C", "#516E7B", "#ECDEAD", "#909191", "#DE6379", "#63B1DB", "#FFD679", "#FFBD7E", "#EC5374", "#C03951", "#3B9DD1", "#FFCA50", "#8FAC8D", "#FFA855", "#728892", "#E1274F", "#84071D", "#0675B0", "#D59606", "#4D744B", "#CD6A0C", "#385967", "#C8B677", "#747777", "#9E0022", "#5C0010", "#178BCA", "#A87500", "#2E552C", "#A24F00", "#224453", "#A6924A", "#5A5F5F", "#78001A"]);
            //this.color = d3.scaleOrdinal().range(["#DE6379", "#178BCA", "#D59606", "#6A8F68", "#F28D2C", "#516E7B", "#ECDEAD", "#909191", "#C03951", "#63B1DB", "#FFCC59", "#8FAC8D", "#FFBD7E", "#768D97", "#C8B677", "#757878", "#EC5374", "#84071D", "#3B9DD1", "#F6B82A", "#6B9A69", "#FFA855", "#728892", "#A7934D", "#5B5F5F", "#E1274F", "#7E061B", "#0675B0", "#AD7900", "#4D744B", "#CD6A0C", "#385967", "#A6924A", "#424646", "#9E0022", "#5C0010", "#178BCA", "#845C00", "#2E552C", "#A24F00", "#224453", "#89742C", "#252A2A", "#78001A"]);
            var el = $(this.options.visSelector);
            el.addClass("vis-loading");

            this.visContainer = el.closest("[data-role='vis-container']");
            if (this.visContainer) {
                $(this.visContainer).after("<div data-role='vis-nodata' data-role-for='" + this.options.visSelector + "'>No data available.</div>");
                this.visNoData = $("[data-role='vis-nodata'][data-role-for='" + this.options.visSelector + "']");
                this.visNoData.hide();
            }

            var visWidth = el.width() - (this.options.margins.left + this.options.margins.right);

            this.visDimensions = { height: this.options.visHeight, width: visWidth, margins: this.options.margins };

            this.updateDataSource(true, this.processingFunction);
        }
    };

    return myVis;
}());

app.Vis.Scatter = (function () {
    var myVis = function (options) {
        this.options = {
            name: "scatter", keySelector: "", tooltipSelector: "", visSelector: "", visHeight: 450, margins: { top: 20, right: 20, bottom: 50, left: 60 },
            fieldNames: { key: "key", x: "x", y: "y", r: "r", filter1: "filter1" },
            keyHeight: 0, keyMargins: { top: 0, right: 0, bottom: 0, left: 0 }, xAxisLabel: "X Axis", yAxisLabel: "Y Axis", excludedCategories: [], highlightedCategory: ''
        };
        this.options = $.extend({}, this.options, options);

        app.Vis.Visualization.call(this);

        this.elements = { zeroLine: null }

        this.xScale = d3.scaleLinear().range([0, this.visDimensions.width]);
        this.yScale = d3.scaleLinear().range([0, this.visDimensions.height]);
        this.yScaleReverse = d3.scaleLinear().range([0, this.visDimensions.height]);
        this.rScale = d3.scaleSqrt().range([3, 80]);
        this.xAxis = d3.axisBottom(this.xScale).tickSize(5);
        this.yAxis = d3.axisLeft(this.yScaleReverse);
        if (app.page.isPageSmall() || app.page.isPageMedium()) {
            this.xAxis.ticks(5);
        }
    }

    myVis.prototype.filter = function (fieldName, value) {
        return this.data = this.data.filter(function (d) { return (d[fieldName] === value.toString()); });
    };
    myVis.prototype.filterCategories = function (excludedCategories) {
        var keyName = this.options.fieldNames.key;
        return this.data = this.data.filter(function (d) { return (excludedCategories.indexOf(d[keyName])) === -1; });
    };
    myVis.prototype.hideDetails = function () {
        d3.select(this.options.tooltipSelector).classed('hidden', true);
        this.body.selectAll(".point").selectAll("circle").attr("opacity", 0.85);
        this.body.select(".crosshairs").remove();
    };
    myVis.prototype.showDetails = function (pointData, index, element) {
        var box = {
            x: Math.round(this.xScale(pointData[this.options.fieldNames.x])) + this.visDimensions.margins.left + $(this.options.visSelector).offset().left,
            y: Math.round(this.yScaleReverse(pointData[this.options.fieldNames.y])) - (this.visDimensions.margins.top + this.rScale(pointData[this.options.fieldNames.r])) + $(this.options.visSelector).offset().top
        };

        var msg = this.getTooltip(pointData);

        d3.select(this.options.tooltipSelector).classed('hidden', false);
        d3.select(this.options.tooltipSelector + ' .content').html(msg);
        d3.select(this.options.tooltipSelector).style('left', "" + (box.x - 150) + "px").style('top', "" + (box.y - $(this.options.tooltipSelector).height()) + "px");

        this.body.selectAll(".point circle").attr("opacity", 0.3);
        d3.select(element).select("circle").attr("opacity", 1.0);

        var crosshairs = this.body.insert("g", "#dataSet-" + this.options.name).attr("class", "crosshairs");
        crosshairs.append("line").attr("class", "vis-crosshair").attr("x1", 0 + 3).attr("x2", this.xScale(pointData[this.options.fieldNames.x]) - this.rScale(pointData[this.options.fieldNames.r])).attr("y1", this.yScale(pointData[this.options.fieldNames.y])).attr("y2", this.yScale(pointData[this.options.fieldNames.y])).attr("stroke-width", 1);
        crosshairs.append("line").attr("class", "vis-crosshair").attr("x1", this.xScale(pointData[this.options.fieldNames.x])).attr("x2", this.xScale(pointData[this.options.fieldNames.x])).attr("y1", 0 + 3).attr("y2", this.yScale(pointData[this.options.fieldNames.y]) - this.rScale(pointData[this.options.fieldNames.r])).attr("stroke-width", 1);
    };
    myVis.prototype.render = function (sourceData) {
        this.allData = sourceData;

        this.baseVis = d3.select(this.options.visSelector).append("svg").attr("width", this.visDimensions.width + this.visDimensions.margins.left + this.visDimensions.margins.right).attr("height", this.visDimensions.height + this.visDimensions.margins.top + this.visDimensions.margins.bottom);
        this.baseVis.append("g").attr("class", "xAxis-" + this.options.name).attr("transform", "translate(" + this.visDimensions.margins.left + "," + (this.visDimensions.height + this.visDimensions.margins.top) + ")").call(this.xAxis);
        this.baseVis.append("text").attr("x", this.visDimensions.width / 2).attr("y", this.visDimensions.height + (this.visDimensions.margins.top + this.visDimensions.margins.bottom) - 10).attr("text-anchor", "middle").attr("transform", "translate(" + this.visDimensions.margins.left + ",0)").text(this.options.xAxisLabel);
        this.baseVis.append("g").attr("class", "yAxis-" + this.options.name).attr("transform", "translate(" + this.visDimensions.margins.left + "," + this.visDimensions.margins.top + ")").call(this.yAxis);

        var vis = this.baseVis.append("g").attr("transform", "translate(" + 0 + "," + (this.visDimensions.height + (this.visDimensions.margins.top + this.visDimensions.margins.bottom)) + ")scale(1,-1)");
        vis.append("text").attr("x", this.visDimensions.height / 2).attr("y", 20).attr("text-anchor", "middle").attr("transform", "rotate(270)scale(-1,1)translate(" + this.visDimensions.margins.bottom + ",0)").text(this.options.yAxisLabel);

        this.body = vis.append("g").attr("transform", "translate(" + this.visDimensions.margins.left + "," + this.visDimensions.margins.bottom + ")");
        this.dataSet = this.body.append("g").attr("id", "dataSet-" + this.options.name);

        this.update();
        this.renderKey();
        $(this.options.visSelector).removeClass("vis-loading");
    };
    myVis.prototype.renderKey = function () {
        var categories = {};
        var vis = this;
        var keyHeight = 30;
        var columns = [this.options.keySelector];

        if ($(this.options.keySelector2).length) {
            columns.push(this.options.keySelector2);
            if ($(this.options.keySelector3).length) {
                columns.push(this.options.keySelector3);
            }
        }

        this.allData.forEach(function (d) { return categories[d[vis.options.fieldNames.key]] = 1; });

        var totalCategories = Object.keys(categories).length;
        var keyDimensions = { height: (Math.ceil(totalCategories / columns.length) * keyHeight), width: $(this.options.keySelector).width(), margins: this.options.keyMargins };
        var key;
        var keyGroup;

        for (var i = 0; i < columns.length; i++) {
            if (columns.hasOwnProperty(i)) {
                key = d3.select(columns[i]).append("svg").attr("width", keyDimensions.width).attr("height", keyDimensions.height + keyDimensions.margins.bottom + keyDimensions.margins.top);
                key = key.append("g").attr("transform", "translate(" + keyDimensions.margins.left + "," + keyDimensions.margins.top + ")");

                keyGroup = key.selectAll(".key-group").data(Object.keys(categories).slice(i * Math.ceil(totalCategories / columns.length), (i + 1) * Math.ceil(totalCategories / columns.length))).enter().append("g").attr("class", "key-group").attr("transform", function (d, i) { return "translate(0," + (i * keyHeight % keyDimensions.height) + ")"; });
                keyGroup.append("rect").attr("width", keyDimensions.width).attr("height", 25).attr("fill", function (d) { return vis.color(d); }).attr("linegroup-block", function (d) { return d; });
                keyGroup.append("text").attr("class", "key-text").attr("dy", 18).attr("dx", 6).text(function (d) { return d; });
                keyGroup.append("rect").attr("width", keyDimensions.width).attr("height", 25).attr("linegroup", function (d) { return d; }).attr("columngroup", columns[i]).attr("opacity", 0)
                    .on('click', function () { return vis.handleCategoryToggle(this); })
                    .on("mouseover", function () { return vis.handleCategoryHover(this); })
                    .on("mouseout", function () { return vis.handleCategoryHoverEnd(this); });
            }
        }
    };
    myVis.prototype.handleCategoryHover = function (element) {
        var lineGroup = d3.select(element).attr("linegroup");
        if (this.options.excludedCategories.indexOf(lineGroup) === -1) {
            this.options.highlightedCategory = lineGroup;
            this.update();
        }
    };
    myVis.prototype.handleCategoryHoverEnd = function (element) {
        this.options.highlightedCategory = '';
        this.update();
    };
    myVis.prototype.handleCategoryToggle = function (element) {
        var lineGroup = d3.select(element).attr("linegroup");
        var columnGroup = d3.select(element).attr("columngroup");
        var index = this.options.excludedCategories.indexOf(lineGroup);
        var el = d3.select(columnGroup).selectAll("[linegroup-block='" + lineGroup + "']");

        if (index === -1) {
            el.attr("opacity", 0);
            this.options.highlightedCategory = '';
            this.options.excludedCategories.push(lineGroup);
        } else {
            el.attr("opacity", 1.0);
            this.options.highlightedCategory = lineGroup;
            this.options.excludedCategories.splice(index, 1);
        }

        this.update();
    };
    myVis.prototype.drawData = function () {
        var points = this.dataSet.selectAll(".point").data(this.data, function (d) { return d.Id; });
        var t = d3.transition().duration(1000).ease(d3.easeLinear);
        var myVis = this;

        if (!myVis.data) {
            myVis.visNoData.show();
            myVis.visContainer.hide();
        } else {
            myVis.visNoData.hide();
            myVis.visContainer.show();
        }

        if (this.data.length) {
            this.baseVis.transition(t).select(".xAxis-" + this.options.name).call(this.xAxis);
            this.baseVis.transition(t).select(".yAxis-" + this.options.name).call(this.yAxis);

            points.enter()
                .append("g")
                .attr("class", "point")
                .on("mouseover", function (d, i) { return myVis.showDetails(d, i, this); })
                .on("mouseout", $.proxy(myVis.hideDetails, this))
                .append("circle")
                .attr("fill", function (d) { return myVis.color(d[myVis.options.fieldNames.key]); })
                .attr("stroke", function (d) { return d3.hsl(myVis.color(d[myVis.options.fieldNames.key])).darker(); })
                .attr("stroke-width", 1)
                .attr("r", function (d) { return myVis.rScale(parseFloat(d[myVis.options.fieldNames.r])); })
                .transition(t)
                .attr("transform", function (d) { return "translate(" + (myVis.xScale(d[myVis.options.fieldNames.x])) + "," + (myVis.yScale(d[myVis.options.fieldNames.y])) + ")"; });

            points.selectAll("circle")
                .attr("opacity", function (d, i) {
                    return myVis.options.highlightedCategory === '' ? .85 : (d[myVis.options.fieldNames.key] === myVis.options.highlightedCategory) ? 1 : .1;
                })
                .transition(t)
                .attr("transform", function (d) { return "translate(" + (myVis.xScale(d[myVis.options.fieldNames.x])) + "," + (myVis.yScale(d[myVis.options.fieldNames.y])) + ")"; })
                .attr("r", function (d) { return myVis.rScale(parseFloat(d[myVis.options.fieldNames.r])); });
        }

        points.exit().selectAll("circle").transition(t).attr("r", 0).attr("transform", function (d) { return "translate(" + 0 + "," + 0 + ")"; });
    };
    myVis.prototype.updateScales = function () {
        var myVis = this;
        if (this.data.length > 0) {
            var xRange = d3.extent(this.data, function (d) { return parseFloat(d[myVis.options.fieldNames.x]); });
            var yRange = d3.extent(this.data, function (d) { return parseFloat(d[myVis.options.fieldNames.y]); });
            var rRange = d3.extent(this.data, function (d) { return parseFloat(d[myVis.options.fieldNames.r]) });

            var x = { padding: { minimum: 0, actual: 0 }, minimum: 0, maximum: xRange[1] };
            var y = { padding: { minimum: 3, actual: 0 }, minimum: yRange[0], maximum: yRange[1] };
            var r = { padding: { minimum: 10, actual: 0 }, minimum: rRange[0], maximum: rRange[1] };

            r.minimum = Math.max(r.minimum - r.padding.actual, 0);
            r.maximum = Math.min(r.maximum + r.padding.actual, 100);
            this.rScale = this.rScale.domain([rRange[0], rRange[1]]);

            x.padding.actual = Math.max(parseInt(Math.abs(x.maximum - x.minimum) / 20), x.padding.minimum);
            console.log('x min:' + x.minimum + 'x max:' + x.maximum + 'x padding:' + x.padding.actual);

            this.xScale.domain([x.minimum - x.padding.actual, x.maximum + x.padding.actual]);
            if (this.options.xAxisFormat === "money") {
                this.xAxis.tickFormat(function (d) { return app.page.getFormattedNumber(d, "$"); });
            }

            this.yAxis.tickFormat(function (d) { return app.page.getShortFriendlyNumber(d); });

            y.padding.actual = Math.max(parseInt(Math.abs(y.maximum - y.minimum) / 5), y.padding.minimum);
            y.minimum = Math.max(
                //y.minimum - y.padding.actual
                0
                , 0);
            y.maximum = Math.min(y.maximum + y.padding.actual);
            this.yScale.domain([y.minimum, y.maximum]);
            this.yScaleReverse.domain([y.maximum, y.minimum]);
        }
    };
    myVis.prototype.getTooltip = function () { };

    return myVis;
}());
app.Vis.LineGraph = (function () {
    var myVis = function (options) {
        this.options = {
            name: "linegraph", keySelector: "", moreDetails: false, xDateScale: false, tooltipSelector: "", visSelector: "", visHeight: 450, margins: { top: 20, right: 30, bottom: 50, left: 60 },
            fieldNames: { key: "key", x: "x", y: "y", filter1: "filter1" },
            keyHeight: 0, keyMargins: { top: 10, right: 10, bottom: 10, left: 15 }, xAxisLabel: "X Axis", yAxisLabel: "Y Axis", excludedCategories: [], highlightedCategory: ''
        };
        this.options = $.extend({}, this.options, options);

        app.Vis.Visualization.call(this);

        this.elements = { hoverContainer: null };
        this.lineData = null;
        this.lines = null;

        this.xScale = (this.options.xDateScale) ? d3.scaleTime().range([0, this.visDimensions.width]) : d3.scaleLinear().range([0, this.visDimensions.width]);
        this.yScale = d3.scaleLinear().range([0, this.visDimensions.height]);
        this.yScaleReverse = d3.scaleLinear().range([0, this.visDimensions.height]);
        this.xAxis = (this.options.xDateScale) ? d3.axisBottom(this.xScale) : d3.axisBottom(this.xScale).tickSize(5);
        this.yAxis = d3.axisLeft(this.yScaleReverse);
    }

    myVis.prototype.filter = function (fieldName, value) {
        return this.data = this.data.filter(function (d) { return (d[fieldName] === value.toString()); });
    };
    myVis.prototype.filterCategories = function (excludedCategories) {
        var keyName = this.options.fieldNames.key;
        return this.data = this.data.filter(function (d) { return (excludedCategories.indexOf(d[keyName])) === -1; });
    };
    myVis.prototype.handleMouseMove = function (event) {
        // mouse moving over canvas
        var myVis = this;
        var xPosition = d3.pointer(event)[0] - this.visDimensions.margins.left;
        //var lines = document.getElementsByClassName('line');
        var lines = myVis.lines._groups[0];
        var bisect = d3.bisector(function (d) { return d[myVis.options.fieldNames.x]; }).left;
        var x0 = myVis.xScale.invert(xPosition);

        d3.selectAll(".mouse-per-line-" + this.options.name).attr("transform", function (d, i) {
            if (i >= lines.length) {
                d3.select(this).select('circle').attr('opacity', 0);
                d3.select(this).select('text').attr('opacity', 0);
                return "translate(0,0)";
            }

            var beginning = 0;
            var end = lines[i].getTotalLength();
            var target;
            var pos;
            while (true) {
                target = Math.floor((beginning + end) / 2);
                pos = lines[i].getPointAtLength(target);

                if ((target === end || target === beginning) && pos.x !== xPosition) { break; }

                if (pos.x > xPosition) end = target;
                else if (pos.x < xPosition) beginning = target;
                else break;
            }

            var b = bisect(d[1], x0);
            var v = x0 - d[1][Math.max(b - 1, 0)][myVis.options.fieldNames.x] >= 1 ? d[1][Math.min(b, d[1].length - 1)][myVis.options.fieldNames.y] : d[1][Math.max(b - 1, 0)][myVis.options.fieldNames.y];

            d3.select(this).select('circle').style("stroke", myVis.color(d.key));
            d3.select(this).select('text').text(v);

            return "translate(" + (pos.x + myVis.visDimensions.margins.left) + "," + Math.abs(pos.y - (myVis.visDimensions.height + myVis.visDimensions.margins.top)) + ")";
        });
    };
    myVis.prototype.handleMouseOut = function () {
        d3.select(".mouse-line-" + this.options.name).style("opacity", "0");
        d3.selectAll(".mouse-per-line-" + this.options.name + " circle").style("opacity", "0");
        d3.selectAll(".mouse-per-line-" + this.options.name + " text").style("opacity", "0");
    };
    myVis.prototype.handleMouseOver = function () {
        d3.select(".mouse-line-" + this.options.name).style("opacity", "1");
        d3.selectAll(".mouse-per-line-" + this.options.name + " circle").style("opacity", "1");
        d3.selectAll(".mouse-per-line-" + this.options.name + " text").style("opacity", "1");
    };
    myVis.prototype.render = function (sourceData) {
        var myVis = this;
        this.allData = sourceData;

        this.baseVis = d3.select(this.options.visSelector).append("svg").attr("width", this.visDimensions.width + this.visDimensions.margins.left + this.visDimensions.margins.right).attr("height", this.visDimensions.height + this.visDimensions.margins.top + this.visDimensions.margins.bottom);
        this.baseVis.append("g").attr("class", "xAxis-" + this.options.name).attr("transform", "translate(" + this.visDimensions.margins.left + "," + (this.visDimensions.height + this.visDimensions.margins.top) + ")").call(this.xAxis);
        this.baseVis.append("text").attr("x", this.visDimensions.width / 2).attr("y", this.visDimensions.height + (this.visDimensions.margins.top + this.visDimensions.margins.bottom) - 10).attr("text-anchor", "middle").attr("transform", "translate(" + this.visDimensions.margins.left + ",0)").text(this.options.xAxisLabel);
        this.baseVis.append("g").attr("class", "yAxis-" + this.options.name).attr("transform", "translate(" + this.visDimensions.margins.left + "," + this.visDimensions.margins.top + ")").call(this.yAxis);

        var vis = this.baseVis.append("g").attr("transform", "translate(" + 0 + "," + (this.visDimensions.height + (this.visDimensions.margins.top + this.visDimensions.margins.bottom)) + ")scale(1,-1)");
        vis.append("text").attr("x", this.visDimensions.height / 2).attr("y", 20).attr("text-anchor", "middle").attr("transform", "rotate(270)scale(-1,1)translate(" + this.visDimensions.margins.bottom + ",0)").text(this.options.yAxisLabel);

        this.body = vis.append("g").attr("transform", "translate(" + this.visDimensions.margins.left + "," + this.visDimensions.margins.bottom + ")");

        if (this.options.moreDetails) {
            this.elements.hoverContainer = this.baseVis.append("g").attr("class", "mouse-over-effects");

            this.baseVis.attr('pointer-events', 'all')
                .on('mouseout', function () { return myVis.handleMouseOut(this); })
                .on('mouseover', function () { return myVis.handleMouseOver(this); })
                .on('mousemove', function (ev) { return myVis.handleMouseMove(ev); });
        }

        this.dataSet = this.body.append("g").attr("id", "dataSet");

        this.update();
        this.renderKey();
        $(this.options.visSelector).removeClass("vis-loading");
    };
    myVis.prototype.renderKey = function () {
        var keyName = this.options.fieldNames.key;
        var categories = {};
        var vis = this;
        var keyHeight = 30;
        var columns = [this.options.keySelector];

        if ($(this.options.keySelector2).length) {
            columns.push(this.options.keySelector2);
            if ($(this.options.keySelector3).length) {
                columns.push(this.options.keySelector3);
            }
        }

        this.allData.forEach(function (d) { return categories[d[keyName]] = d["TagId"]; });

        var totalCategories = Object.keys(categories).length;
        var keyDimensions = { height: (Math.ceil(totalCategories / columns.length) * keyHeight), width: $(this.options.keySelector).width(), margins: this.options.keyMargins };
        var key;
        var keyGroup;

        for (var i = 0; i < columns.length; i++) {
            if (columns.hasOwnProperty(i)) {
                key = d3.select(columns[i]).append("svg").attr("width", keyDimensions.width).attr("height", keyDimensions.height + keyDimensions.margins.bottom + keyDimensions.margins.top);
                key = key.append("g").attr("transform", "translate(" + keyDimensions.margins.left + "," + keyDimensions.margins.top + ")");

                keyGroup = key.selectAll(".key-group").data(Object.keys(categories).slice(i * Math.ceil(totalCategories / columns.length), (i + 1) * Math.ceil(totalCategories / columns.length))).enter().append("g").attr("class", "key-group").attr("transform", function (d, i) { return "translate(0," + (i * keyHeight % keyDimensions.height) + ")"; });
                keyGroup.append("rect").attr("width", keyDimensions.width).attr("height", 25).attr("fill", function (d) { return vis.color(d); }).attr("linegroup-block", function (d) { return d; });
                keyGroup.append("text").attr("class", "key-text").attr("dy", 18).attr("dx", 6).text(function (d) { return d; });
                keyGroup.append("rect").attr("width", keyDimensions.width).attr("height", 25).attr("linegroup", function (d) { return d; }).attr("columngroup", columns[i]).attr("opacity", 0)
                    .on('click', function () { return vis.handleCategoryToggle(this); })
                    .on("mouseover", function () { return vis.handleCategoryHover(this); })
                    .on("mouseout", function () { return vis.handleCategoryHoverEnd(this); });
            }
        }

        return;
    };
    myVis.prototype.handleCategoryHover = function (element) {
        var lineGroup = d3.select(element).attr("linegroup");
        if (this.options.excludedCategories.indexOf(lineGroup) === -1) {
            this.options.highlightedCategory = lineGroup;
            this.update();
        }
    };
    myVis.prototype.handleCategoryHoverEnd = function (element) {
        this.options.highlightedCategory = '';
        this.update();
    };
    myVis.prototype.handleCategoryToggle = function (element) {
        var lineGroup = d3.select(element).attr("linegroup");
        var columnGroup = d3.select(element).attr("columngroup");
        var index = this.options.excludedCategories.indexOf(lineGroup);
        var el = d3.select(columnGroup).selectAll("[linegroup-block='" + lineGroup + "']");

        if (index === -1) {
            el.attr("opacity", 0);
            this.options.highlightedCategory = '';
            this.options.excludedCategories.push(lineGroup);
        } else {
            el.attr("opacity", 1.0);
            this.options.highlightedCategory = lineGroup;
            this.options.excludedCategories.splice(index, 1);
        }

        this.update();
    };
    myVis.prototype.drawData = function () {
        var t = d3.transition().duration(1000).ease(d3.easeLinear);
        var myVis = this;

        if (!myVis.data) {
            myVis.visNoData.show();
            myVis.visContainer.hide();
        } else {
            myVis.visNoData.hide();
            myVis.visContainer.show();
        }

        var zerolineDefinition = d3.line().x(function (d) {
            return myVis.xScale(d[myVis.options.fieldNames.x]);
        }).y(function (d) { return myVis.yScale(0); }).curve(d3.curveCardinal.tension(0));
        var lineDefinition = d3.line().x(
            function (d) {
                return myVis.xScale(d[myVis.options.fieldNames.x]);
            }).y(function (d) {
                return myVis.yScale(d[myVis.options.fieldNames.y]);
            }).curve(d3.curveMonotoneX);
        var sortedData = this.data.slice().sort((a, b) => d3.ascending(a[myVis.options.fieldNames.x], b[myVis.options.fieldNames.x]));
        //var grouped = sortedData.reduce((acc, currentValue) => {
        //    let groupKey = currentValue[myVis.options.fieldNames.key];
        //    if (!acc[groupKey]) {
        //        acc[groupKey] = [];
        //    }
        //    acc[groupKey].push(currentValue);
        //    return acc;
        //}, {});

        //this.lineData = grouped;
        this.lineData = Array.from(d3.group(sortedData, function (d) { return d[myVis.options.fieldNames.key]; }));
        this.baseVis.transition(t).select(".xAxis-" + this.options.name).call(this.xAxis);
        this.baseVis.transition(t).select(".yAxis-" + this.options.name).call(this.yAxis);


        this.lines = this.dataSet.selectAll(".line").data(this.lineData, function (d) { return d ? d[0] : this.id; });
        this.lines.exit().transition(t).attr("stroke-width", 0).attr("d", function (d) { return zerolineDefinition(d[1]); }).remove();

        this.lines = this.lines.enter()
            .append("path")
            .attr("class", "line")
            .attr("d", function (d) { return zerolineDefinition(d[1]); })
            .merge(this.lines)
            .attr("opacity", function (d, i) {
                return myVis.options.highlightedCategory === '' ? .85 : (d[0] === myVis.options.highlightedCategory) ? 1 : .1;
            })
            .transition(t)
            .attr("stroke", function (d) { return d3.hsl(myVis.color(d[0])); })
            .attr("stroke-width", 5)
            .attr("d", function (d) { return lineDefinition(d[1]); })
            .style("fill", "none");

        if (this.options.moreDetails) {
            var mousePerLine = this.elements.hoverContainer.selectAll(".mouse-per-line-" + this.options.name);
            var mouseData = mousePerLine.data(this.lineData);

            var mouseG = mouseData.enter()
                .append("g")
                .attr("class", "mouse-per-line-" + this.options.name);
            mouseG.append("circle")
                .attr("r", 7)
                .style("fill", "none")
                .style("stroke-width", "2px")
                .style("opacity", "0");
            mouseG.append("text")
                .attr("transform", "translate(10,3)");

            mouseData.exit().remove();
        }
    };
    myVis.prototype.updateScales = function () {
        var xName = this.options.fieldNames.x;
        var yName = this.options.fieldNames.y;
        var xRange = d3.extent(this.data, function (d) { return parseFloat(d[xName]); });
        if (this.options.xDateScale)
            xRange = d3.extent(this.data, function (d) { return new Date(d[xName]); });
        var yRange = d3.extent(this.data, function (d) { return parseFloat(d[yName]); });

        var y = { padding: { minimum: 0, actual: 0 }, minimum: 0, maximum: yRange[1] };

        this.xScale.domain([xRange[0], xRange[1]]);

        if (this.options.xDateScale) {

        } else {
            this.xAxis.ticks(xRange[1] - xRange[0]).tickFormat(d3.format("0000"));
        }
        y.minimum = Math.max(y.minimum, 0);
        y.maximum = Math.max(y.maximum, 1);
        this.yScale.domain([y.minimum, y.maximum]);
        this.yScaleReverse.domain([y.maximum, y.minimum]).nice();
    };

    return myVis;
}());
app.Vis.ForceGraph = (function () {
    var myVis = function (options) {
        this.options = {
            name: "force", keySelector: "", tooltipSelector: "", visSelector: "", visHeight: 600, margins: { top: 15, right: 15, bottom: 15, left: 15 }, year: "all",
            fieldNames: { key: "key", x: "x", y: "y", r: "r", filter1: "filter1" },
            keyHeight: 0, keyMargins: { top: 10, right: 10, bottom: 10, left: 15 },
            baseStrength: .03, baseAlphaDecay: .001, baseVelocityDecay: .1, currentView: 1,
            typeLabel1: "", typeLabel2: ""
        };
        this.options = $.extend({}, this.options, options);

        app.Vis.Visualization.call(this);

        this.elements = { label: null };

        this.groupedData = {};
        this.nodes = {};
        this.textNodes = {};
        this.countNodes = {};
        this.categories = {};
        this.categoryPrimaryNodes = {};
        this.categoryCount = 0;
        this.baseHeight = this.visDimensions.height + this.visDimensions.margins.top + this.visDimensions.margins.bottom;
        this.xScale = d3.scaleLinear().range([0, this.visDimensions.width]);
        this.yScale = d3.scaleLinear().range([0, this.visDimensions.height]);
        this.rScale = d3.scaleSqrt().range([3, 110]);
        //this.rBound = this.rScale(this.options.boundingValue);
        this.xCenter = this.visDimensions.width / 2;
        this.yCenter = this.visDimensions.height / 2;
    };

    myVis.prototype.filter = function (fieldName, value) {
        return this.data = this.data.filter(function (d) { return (d[fieldName] === value.toString()); });
    };
    myVis.prototype.filterGroupedData = function (fieldName, value) {
        return this.groupedData = this.groupedData.filter(function (d) { return (d[fieldName] === value.toString()); });
    };
    myVis.prototype.hideDetails = function () {
        d3.select(this.options.tooltipSelector).classed('hidden', true);
        this.nodes.attr("opacity", 0.85);
    };
    myVis.prototype.showDetails = function (pointData, index, element) {
        var e = $(element);
        var box = {
            x: Number(e.attr('cx')) + this.visDimensions.margins.left + $(this.options.visSelector).offset().left,
            y: Number(e.attr('cy')) - this.visDimensions.margins.top + $(this.options.visSelector).offset().top - Number(e.attr('r'))
        };

        var msg = this.getTooltip(pointData);

        d3.select(this.options.tooltipSelector).classed('hidden', false);
        d3.select(this.options.tooltipSelector + ' .content').html(msg);
        d3.select(this.options.tooltipSelector).style('left', "" + (box.x - 150) + "px").style('top', "" + (box.y - $(this.options.tooltipSelector).height()) + "px");

        this.nodes.attr("opacity", .3);
        d3.select(element).attr("opacity", 1.0);
    };
    myVis.prototype.buildData = function () { console.log('buildData is a required method for force graphs.'); };
    myVis.prototype.render = function (sourceData) {
        var categories = {};
        var vis = this;
        var rRange = d3.extent(sourceData, function (d) { return parseFloat(d[vis.options.fieldNames.r]) });

        sourceData.forEach(function (d) { return categories[d[vis.options.fieldNames.key]] = 1; });

        this.categories = categories;
        this.categoryCount = Object.keys(categories).length;
        this.rScale = this.rScale.domain([0, rRange[1]]);
        this.allData = this.buildData(sourceData);

        this.baseVis = d3.select(this.options.visSelector).append("svg").attr("width", this.visDimensions.width + this.visDimensions.margins.left + this.visDimensions.margins.right).attr("height", this.baseHeight);
        this.body = this.baseVis.append("g").attr("transform", "translate(" + this.visDimensions.margins.left + "," + this.visDimensions.margins.bottom + ")");
        this.force = d3.forceSimulation().alphaDecay(this.options.baseAlphaDecay).velocityDecay(this.options.baseVelocityDecay);

        this.update();
        this.renderKey();
        $(this.options.visSelector).removeClass("vis-loading");
    };
    myVis.prototype.renderKey = function () {
        var vis = this;
        var keyR = 10;
        var columns = [this.options.keySelector];

        if ($(this.options.keySelector2).length) {
            columns.push(this.options.keySelector2);
            if ($(this.options.keySelector3).length) {
                columns.push(this.options.keySelector3);
            }
        }

        var keyDimensions = { height: (this.categoryCount * 25) / columns.length, width: $(this.options.keySelector).width(), margins: this.options.keyMargins };
        var key;
        var keyGroup;

        for (var i = 0; i < columns.length; i++) {
            if (columns.hasOwnProperty(i)) {
                key = d3.select(columns[i]).append("svg").attr("width", keyDimensions.width).attr("height", keyDimensions.height + keyDimensions.margins.bottom + keyDimensions.margins.top);
                key = key.append("g").attr("transform", "translate(" + keyDimensions.margins.left + "," + keyDimensions.margins.top + ")");

                keyGroup = key.selectAll(".key-group").data(Object.keys(this.categories).slice(i * Math.ceil(this.categoryCount / columns.length), (i + 1) * Math.ceil(this.categoryCount / columns.length))).enter().append("g").attr("class", "key-group").attr("transform", function (d, i) { return "translate(0," + (i * 25 % keyDimensions.height) + ")"; });
                keyGroup.append("circle").attr("r", keyR).attr("fill", function (d) { return vis.color(d); }).attr("transform", function (d) { return "translate(" + keyR + ", " + keyR + ")"; });
                keyGroup.append("text").attr("class", "key-text").attr("dy", 15).attr("dx", keyR * 2 + 6).text(function (d) { return d; });
            }
        }
    };
    myVis.prototype.drawData = function () {
        var t = d3.transition().duration(1000).ease(d3.easeLinear);
        var myVis = this;

        if (!myVis.data) {
            myVis.visNoData.show();
            myVis.visContainer.hide();
        } else {
            myVis.visNoData.hide();
            myVis.visContainer.show();
        }

        this.nodes = myVis.body.selectAll("circle").data(this.data);
        this.nodes.exit().transition(t).attr("r", function (d) { return 0; }).remove();
        this.nodes = this.nodes.enter()
            .append("circle")
            .attr("r", 0)
            .attr("stroke-width", 1)
            .merge(this.nodes)
            .on("mouseover", function (d, i) { return myVis.showDetails(d, i, this); })
            .on("mouseout", $.proxy(myVis.hideDetails, this))
            .attr("cx", function (d) { return d.x; })
            .attr("cy", function (d) { return d.y; })
            .attr("opacity", 0.85)
            .attr("fill", function (d) { return myVis.color(d[myVis.options.fieldNames.key]); })
            .attr("stroke", function (d) { return d3.hsl(myVis.color(d[myVis.options.fieldNames.key])).darker(); });

        this.nodes.transition(t).attr("r", function (d) { return d.r; });


        if (this.options.groupedSourcePath && this.options.groupedSourcePath !== "") {
            this.groupedData = $.map(this.groupedData, function (v, i) {
                var k = v[myVis.options.fieldNames.key];
                var val = v[myVis.options.fieldNames.r]
                return { key: k, value: val };
            });
        }
        else {
            this.groupedData = d3.nest().key(function (d) { return d[myVis.options.fieldNames.key]; }).rollup(function (v) { return d3.sum(v, function (d) { return d[myVis.options.fieldNames.r]; }); }).entries(this.data).sort(function (a, b) { return d3.descending(a.value, b.value) });
        }

        if (this.options.currentView !== 2) {
            //hide labels
            myVis.body.selectAll(".label-text").remove();
        }

        this.baseVis.transition(t).attr("height", this.baseHeight);

        var rowSize = 3;

        if (app.page.isPageMedium()) {
            rowSize = 1;
        } else if (app.page.isPageLarge()) {
            rowSize = 2;
        }

        this.textNodes = myVis.body.selectAll(".group-text").data((this.options.currentView === 3) ? this.groupedData : {});
        this.textNodes.exit().remove();
        this.textNodes = this.textNodes.enter()
            .append("text")
            .attr("class", "group-text")
            .attr("text-anchor", "middle")
            .attr("font-size", "18px")
            .attr("font-weight", "bold")
            .style("fill", "black")
            .merge(this.textNodes)
            .attr('transform', function (d, i) { return 'translate(' + (((i % rowSize)) * (myVis.xCenter / (rowSize / 2)) + myVis.xCenter / rowSize) + ', ' + (75 + Math.floor(i / rowSize) * 250) + ')'; })
            .text(function (d) { return d.key })
            .style("opacity", 0).transition().duration(600).ease(d3.easeLinear).style("opacity", 1);

        this.countNodes = myVis.body.selectAll(".group-count").data((this.options.currentView === 3) ? this.groupedData : {});
        this.countNodes.exit().remove();
        this.countNodes = this.countNodes.enter()
            .append("text")
            .attr("class", "group-count")
            .attr("text-anchor", "middle")
            .attr("font-size", "18px")
            .style("fill", "black")
            .merge(this.countNodes)
            .attr('transform', function (d, i) { return 'translate(' + (((i % rowSize)) * (myVis.xCenter / (rowSize / 2)) + myVis.xCenter / rowSize) + ', ' + (75 + 20 + Math.floor(i / rowSize) * 250) + ')'; })
            .text(function (d) { return app.page.getFormattedNumber(d.value) })
            .style("opacity", 0).transition().duration(600).ease(d3.easeLinear).style("opacity", 1);

        this.force.nodes(this.data).velocityDecay(.5).stop();

        switch (this.options.currentView) {
            case 2:
                this.clusterView();
                break;
            case 3:
                this.detailView(rowSize);
                break;
            default:
                this.overviewView();
                break;
        }

        $('.vis-overlay[data-overlay]', this.options.visSelector).hide();
        $('.vis-overlay[data-overlay="' + this.options.currentView + '"]', this.options.visSelector).fadeIn(200);
    };

    return myVis;
})();
app.Vis.Gauge = (function () {
    //Copyright (c) 2015, Curtis Bratton 
    //All rights reserved.
    var myVis = function (options) {
        this.options = {
            name: "guage", visSelector: "", visHeight: 150, margins: { top: 15, right: 15, bottom: 15, left: 15 },
            fieldNames: { n: "n", m: "m", filter1: "filter1" },
            waveColor: "#178BCA", waveTextColor: "#FFFFFF", textColor: "#045681", circleColor: "#178BCA",
            waveRise: true, waveRiseTime: 2000, countUp: true, displayPercent: true, guid: app.util.getGuid()
        };
        this.options = $.extend({}, this.options, options);

        app.Vis.Visualization.call(this);

        this.elements = { outerCircle: null, text1: null, text2: null, wave: null, waveGroup: null, fillCircleGroup: null, fillCircleGroupCircle: null, label: null };

        this.radius = Math.min(parseInt(this.visDimensions.width), parseInt(this.visDimensions.height)) / 2;
        this.textPixels = this.radius / 2;
        this.locationX = parseInt(this.visDimensions.width) / 2 - this.radius + this.visDimensions.margins.left;
        this.locationY = parseInt(this.visDimensions.height) / 2 - this.radius + this.visDimensions.margins.top + this.textPixels * .75;
        this.waveHeightScale = d3.scaleLinear().range([0, .05, 0]).domain([0, 50, 100]);
        this.percentText = this.options.displayPercent ? '%' : '';
        this.fillCircleMargin = 2 * .05 * this.radius;
        this.fillCircleRadius = this.radius - this.fillCircleMargin;
        this.waveLength = this.fillCircleRadius * 2 / 4;
        this.waveClipWidth = this.waveLength * 5;
        this.waveAnimateScale = d3.scaleLinear().range([0, this.waveClipWidth - this.fillCircleRadius * 2]).domain([0, 1]);
    }

    myVis.prototype.filter = function (fieldName, value) {
        return this.data = this.data.filter(function (d) { return (d[fieldName] === value.toString()); });
    };
    myVis.prototype.render = function (sourceData) {
        this.allData = sourceData;
        $(this.options.visSelector).html('');
        this.baseVis = d3.select(this.options.visSelector).append("svg").attr("width", this.visDimensions.width + this.visDimensions.margins.left + this.visDimensions.margins.right).attr("height", this.visDimensions.height + this.visDimensions.margins.top + this.visDimensions.margins.bottom + this.textPixels * .75);
        this.body = this.baseVis.append("g").attr('transform', 'translate(' + this.locationX + ',' + this.locationY + ')');
        this.elements.outerCircle = this.body.append("path");
        this.elements.text1 = this.body.append("text");
        this.elements.waveGroup = this.body.append("defs").append("clipPath").attr("id", "clipWave" + this.options.guid);
        this.elements.wave = this.elements.waveGroup.append("path");
        this.elements.fillCircleGroup = this.body.append("g").attr("clip-path", "url(#clipWave" + this.options.guid + ")");
        this.elements.fillCircleGroupCircle = this.elements.fillCircleGroup.append("circle");
        this.elements.text2 = this.elements.fillCircleGroup.append("text");

        this.elements.label = this.baseVis.append("text").attr("class", "key-text").attr("text-anchor", "middle").attr("font-size", this.textPixels * .75 + "px").style("fill", this.options.textColor).attr('transform', 'translate(' + (this.visDimensions.width + this.visDimensions.margins.left + this.visDimensions.margins.right) / 2 + ', 30)');

        this.gaugeCircleX = d3.scaleLinear().range([0, 2 * Math.PI]).domain([0, 1]);
        this.gaugeCircleY = d3.scaleLinear().range([0, this.radius]).domain([0, this.radius]);

        this.update();
        this.renderKey();
        $(this.options.visSelector).removeClass("vis-loading");
    };
    myVis.prototype.renderKey = function () {
        this.elements.label.text(this.data[0][this.options.fieldNames.key]);
    };
    myVis.prototype.roundText = function (v) {
        if (parseFloat(v).toString() === parseFloat(v).toFixed(0)) return function (v) { return parseFloat(v).toFixed(0); };
        if (parseFloat(v).toString() === parseFloat(v).toFixed(1)) return function (v) { return parseFloat(v).toFixed(1); };
        return function (v) { return parseFloat(v).toFixed(2); };
    }
    myVis.prototype.drawData = function () {
        var myVis = this;
        var data = [];

        if (this.data.length === 0) {
            this.data = [{}];
            this.data[0][this.options.fieldNames.key] = "";
            this.data[0][this.options.fieldNames.n] = 0;
            this.data[0][this.options.fieldNames.m] = 0;
            this.data[0][this.options.fieldNames.filter1] = "";
        }

        if (myVis.options.fieldNames.m === "") {
            if (this.data.length === 0) {
                this.textFinal = 0;
                this.fill = 0;
            } else {
                this.textFinal = parseFloat(this.data[0][myVis.options.fieldNames.n]).toFixed(1);
                this.fill = 1;
            }
        } else {
            this.textFinal = ((parseFloat(this.data[0][myVis.options.fieldNames.n]) / parseFloat(this.data[0][myVis.options.fieldNames.m]) * 100) || 0).toFixed(1);
            this.fill = Math.max(0, this.data[0][myVis.options.fieldNames.n] / this.data[0][myVis.options.fieldNames.m]) || 0;
        }

        var roundText = this.roundText(this.textFinal);

        this.textInitial = this.options.countUp ? 0 : this.textFinal;
        this.waveHeight = this.fillCircleRadius * this.waveHeightScale(this.fill * 100);

        for (var i = 0; i <= 200; i++) {
            data.push({ x: i / 200, y: (i / 40) });
        }

        var currentText = roundText(this.textInitial) + this.percentText;
        var waveScaleX = d3.scaleLinear().range([0, this.waveClipWidth]).domain([0, 1]);
        var waveScaleY = d3.scaleLinear().range([0, this.waveHeight]).domain([0, 1]);

        var waveRiseScale = d3.scaleLinear().range([(this.fillCircleMargin + this.fillCircleRadius * 2 + this.waveHeight), (this.fillCircleMargin - this.waveHeight)]).domain([0, 1]);
        var textRiseScaleY = d3.scaleLinear().range([this.fillCircleMargin + this.fillCircleRadius * 2, (this.fillCircleMargin + this.textPixels * 0.7)]).domain([0, 1]);

        var gaugeCircleArc = d3.arc().startAngle(this.gaugeCircleX(0)).endAngle(this.gaugeCircleX(1)).outerRadius(this.gaugeCircleY(this.radius)).innerRadius(this.gaugeCircleY(this.radius * .95));
        this.elements.outerCircle.attr("d", gaugeCircleArc).style("fill", this.options.circleColor).attr('transform', 'translate(' + this.radius + ',' + this.radius + ')');

        this.elements.text1.text(currentText).attr("text-anchor", "middle").attr("font-size", this.textPixels + "px").style("fill", this.options.textColor).attr('transform', 'translate(' + this.radius + ',' + textRiseScaleY(.5) + ')');
        this.elements.text2.text(currentText).attr("text-anchor", "middle").attr("font-size", this.textPixels + "px").style("fill", this.options.waveTextColor).attr('transform', 'translate(' + this.radius + ',' + textRiseScaleY(.5) + ')');

        // The clipping wave area.
        var waveHeight = this.waveHeight;
        var fillCircleRadius = this.fillCircleRadius;

        // The inner circle with the clipping wave attached.
        this.elements.fillCircleGroupCircle.attr("cx", this.radius).attr("cy", this.radius).attr("r", this.fillCircleRadius).style("fill", this.options.waveColor);

        var clipArea = d3.area().x(function (d) { return waveScaleX(d.x); })
            .y0(function (d) { return waveScaleY(Math.sin(Math.PI * -6 + d.y * 2 * Math.PI)); })
            .y1(function (d) { return (fillCircleRadius * 2 + waveHeight); });

        this.elements.wave.datum(data).attr("d", clipArea).attr("T", 0);

        // Make the value count up.
        if (this.options.countUp) {
            var textFinal = this.textFinal;
            var percentText = this.percentText;

            var textTween = function () {
                var node = this;
                var i = d3.interpolate(node.textContent, textFinal);
                return function (t) {
                    node.textContent = roundText(i(t)) + percentText;
                }
            };

            this.elements.text1.transition().duration(this.options.waveRiseTime).tween("text", textTween);
            this.elements.text2.transition().duration(this.options.waveRiseTime).tween("text", textTween);
        }

        var waveGroupXPosition = this.fillCircleMargin + this.fillCircleRadius * 2 - this.waveClipWidth;
        var fill = this.fill;

        if (this.options.waveRise) {
            this.elements.waveGroup.attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(0) + ')').transition().duration(this.options.waveRiseTime).attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(fill) + ')');
        } else {
            this.elements.waveGroup.attr('transform', 'translate(' + waveGroupXPosition + ',' + waveRiseScale(fill) + ')');
        }

        animateWave(this.elements.wave, this.waveAnimateScale);

        function animateWave(wave, waveAnimateScale) {
            if (wave) {
                wave.attr('transform', 'translate(' + waveAnimateScale(wave.attr('T')) + ',0)');
                wave.transition().duration(1000 * (1 - wave.attr('T'))).ease(d3.easeLinear).attr('transform', 'translate(' + waveAnimateScale(1) + ',0)').attr('T', 1).on('end', function () { wave.attr('T', 0); animateWave(wave, waveAnimateScale); });
            }
        }

        $(this.options.visSelector).removeClass("vis-loading");
    };

    return myVis;
})();
app.Vis.HoverGraph = (function () {
    var myVis = function (options) {
        this.options = {
            name: "hover", keySelector: "", tooltipSelector: "", visSelector: "", visHeight: 600, margins: { top: 15, right: 15, bottom: 15, left: 15 }, year: "all",
            fieldNames: { key: "key", subKey: "subkey", value: "count", filter1: "filter1" },
            textColor: "#045681", circleColor: "#178BCA",
            categoryMargin: 20,
            baseStrength: .03, baseAlphaDecay: .001, baseVelocityDecay: .1, currentView: 1
        };
        this.options = $.extend({}, this.options, options);

        app.Vis.Visualization.call(this);

        this.elements = { label: null };

        this.nodes = {};
        this.textNodes = {};
        this.countNodes = {};
        this.categories = {};
        this.categoryCount = 0;
        this.radius = 0;
        this.xScale = d3.scaleLinear().range([0, this.visDimensions.width]);
        this.yScale = d3.scaleLinear().range([0, this.visDimensions.height]);
        this.rScale = d3.scaleSqrt().range([3, 110]);
        this.xCenter = this.visDimensions.width / 2;
        this.yCenter = this.visDimensions.height / 2;
    };

    myVis.prototype.filter = function (fieldName, value) {
        return this.data = this.data.filter(function (d) { return (d.key === value.toString()); });
    };
    myVis.prototype.hideDetails = function () {
        this.data.forEach(function (d) { d.selected = false; });
        $('.vis-overlay[data-overlay]', this.options.visSelector).hide();
        this.detailView(1);
    };
    myVis.prototype.showDetails = function (pointData, index, element) {
        pointData.selected = true;
        $('.vis-overlay[data-overlay="' + pointData.key + '"]', this.options.visSelector).fadeIn(300);
        this.detailView(1, $('.vis-overlay[data-overlay="' + pointData.key + '"]', this.options.visSelector).height(), pointData.index);
    };
    myVis.prototype.render = function (sourceData) {
        var categories = {};
        var myVis = this;

        sourceData.forEach(function (d) { return categories[d[myVis.options.fieldNames.key]] = 1; });

        this.categories = categories;
        this.categoryCount = Object.keys(categories).length;
        this.radius = Math.min(this.visDimensions.width, this.visDimensions.height / this.categoryCount) / 2;
        this.allData = d3.nest()
            .key(function (d) { return d[myVis.options.fieldNames.filter1]; })
            .key(function (d) { return d[myVis.options.fieldNames.key]; })
            .key(function (d) { return d[myVis.options.fieldNames.subKey]; })
            .rollup(function (v) { return { count: d3.sum(v, function (d) { return d[myVis.options.fieldNames.value]; }), total: v[0][myVis.options.fieldNames.totalValue] } })
            .entries(sourceData).sort(function (a, b) { return d3.descending(a.value, b.value) });
        this.allData.forEach(function (d) {
            d.values.forEach(function (e) {
                e.selected = false;
            });
        });
        this.baseVis = d3.select(this.options.visSelector).append("svg")
            .attr("width", this.visDimensions.width + this.visDimensions.margins.left + this.visDimensions.margins.right)
            .attr("height", this.visDimensions.margins.top + this.visDimensions.margins.bottom + (((myVis.radius * 2) + myVis.options.categoryMargin) * this.categoryCount))
            .on("mouseout", $.proxy(this.hideDetails, this));
        this.body = this.baseVis.append("g").attr("transform", "translate(" + this.visDimensions.margins.left + "," + this.visDimensions.margins.bottom + ")");
        this.force = d3.forceSimulation().alphaDecay(this.options.baseAlphaDecay).velocityDecay(this.options.baseVelocityDecay);

        //create content divs
        Object.keys(categories).forEach(function (d) {
            $(myVis.options.visSelector).append("<div class='vis-overlay hovergraph-overlay' data-overlay='" + d + "'></div>");
        });

        this.update();
        $(this.options.visSelector).removeClass("vis-loading");
    };
    myVis.prototype.drawData = function () {
        var myVis = this;
        var rowSize = 1;

        this.nodes = myVis.body.selectAll("g").data(this.data, function (d) { return d.key; });
        this.nodes.exit().remove();

        var nodesEnter = this.nodes.enter().append("g");

        nodesEnter.append("circle")
            .attr("stroke-width", 1)
            .attr("opacity", 0.85)
            .attr("fill", function (d) { return myVis.options.circleColor; })
            .attr("stroke", function (d) { return d3.hsl(myVis.options.circleColor).darker(); })
            .attr("r", function (d) { return myVis.radius; });

        nodesEnter.append("text")
            .attr("class", "group-label")
            .attr("text-anchor", "middle")
            .attr("font-size", myVis.radius / 4 + "px")
            .attr("font-weight", "bold")
            .attr("transform", "translate(0, " + myVis.radius * .4 + ")")
            .style("fill", myVis.options.textColor)
            .text(d => d.key);

        nodesEnter.append("text")
            .attr("class", "group-value")
            .attr("text-anchor", "middle")
            .attr("font-size", myVis.radius + "px")
            .attr("font-weight", "bold")
            .attr("transform", "translate(0, 0)")
            .style("fill", myVis.options.textColor);

        nodesEnter.append("rect")
            .attr("opacity", "0")
            .attr("width", this.visDimensions.width * 1.5)
            .attr("height", myVis.radius * 2)
            .attr('pointer-events', 'all')
            .attr('transform', 'translate(' + -myVis.xCenter + ', ' + -myVis.radius + ')');

        this.nodes = this.nodes.merge(nodesEnter);
        this.nodes.select("rect").on("mouseover", function (d, i) { return myVis.showDetails(d, i, this); });
        this.nodes.select(".group-value").text(d => d.values[0].value.total).style("opacity", 0).transition().duration(600).ease(d3.easeLinear).style("opacity", 1);

        this.data.forEach(function (d, i) {
            var e = $('.vis-overlay[data-overlay="' + d.key + '"]', myVis.options.visSelector);
            var s = '';

            d.values.forEach(function (d2) { s = s + d2.value.count + ' ' + d2.key + '<br />'; });
            e.html(s);

            var t = (e.height() < (myVis.radius * 2) ? ((myVis.radius * 2) - e.height()) / 2 : 0);

            e.css('left',
                (app.page.isPageSmall() ?
                    myVis.radius / 2 :
                    ((((i % rowSize)) * (myVis.xCenter / (rowSize / 2)) + myVis.xCenter / rowSize)))
                + 'px');
            e.css('top',
                (app.page.isPageSmall() ?
                    myVis.visDimensions.margins.top + (((myVis.radius * 2) + myVis.options.categoryMargin) * (i + 1)) :
                    myVis.visDimensions.margins.top + myVis.options.categoryMargin + (((myVis.radius * 2) + myVis.options.categoryMargin) * i) + t)
                + 'px');
        });

        this.force.nodes(this.data).velocityDecay(.5).stop();

        this.detailView(rowSize);
    };

    return myVis;
})();
app.Vis.BarGraph = (function () {
    var myVis = function (options) {
        this.options = {
            name: "linegraph", keySelector: "", moreDetails: false, xDateScale: false, tooltipSelector: "", visSelector: "", visHeight: 450, margins: { top: 20, right: 20, bottom: 50, left: 60 },
            fieldNames: { key: "key", x: "x", y: "y", filter1: "filter1", filter2: "filter2" },
            keyHeight: 0, keyMargins: { top: 0, right: 0, bottom: 0, left: 0 }, xAxisLabel: "X Axis", yAxisLabel: "Y Axis", excludedCategories: []
        };
        this.options = $.extend({}, this.options, options);

        app.Vis.Visualization.call(this);

        this.categories = {};
        this.keys = {};

        this.xScale = d3.scaleLinear().rangeRound([this.visDimensions.width, 0]);
        this.yScale = d3.scaleLinear().rangeRound([this.visDimensions.height, 0]);
        this.xAxis = d3.axisBottom(this.xScale).tickSize(5);
        this.yAxis = d3.axisLeft(this.yScale).ticks(null, "s");
    }

    myVis.prototype.filter = function (fieldName, value) {
        return this.data = this.data.filter(function (d) { return (d[fieldName] === value.toString()); });
    };
    myVis.prototype.filterLessThan = function (fieldName, value) {
        return this.data = this.data.filter(function (d) { return isNaN(value) || d[fieldName] <= value; });
    };
    myVis.prototype.filterCategories = function (excludedCategories) {
        var keyName = this.options.fieldNames.key;
        return this.data = this.data.filter(function (d) { return (excludedCategories.indexOf(d[keyName])) === -1; });
    };
    myVis.prototype.mungeData = function (sourceData) { };
    myVis.prototype.hideDetails = function () {
        d3.select(this.options.tooltipSelector).classed('hidden', true);
        this.body.selectAll(".point").selectAll("circle").attr("opacity", 0.85);
    };
    myVis.prototype.showDetails = function (pointData, index, element) {
        var box = {
            x: Math.round(this.xScale(pointData.data[this.options.fieldNames.x])) + this.visDimensions.margins.left + $(this.options.visSelector).offset().left + 2,
            y: parseInt($(element).attr('y')) + $(this.options.visSelector).offset().top - 10
        };

        var msg = this.getTooltip(pointData.data, element);

        d3.select(this.options.tooltipSelector).classed('hidden', false);
        d3.select(this.options.tooltipSelector + ' .content').html(msg);
        d3.select(this.options.tooltipSelector).style('left', "" + (box.x - 150) + "px").style('top', "" + (box.y - $(this.options.tooltipSelector).height()) + "px");

        this.body.selectAll(".point circle").attr("opacity", 0.3);
        d3.select(element).select("circle").attr("opacity", 1.0);
    };
    myVis.prototype.render = function (sourceData) {
        var myVis = this;

        this.allData = sourceData;

        this.allData.forEach(function (d) { return myVis.categories[d[myVis.options.fieldNames.key]] = 1; });
        this.keys = Object.keys(this.categories);

        this.baseVis = d3.select(this.options.visSelector).append("svg").attr("width", this.visDimensions.width + this.visDimensions.margins.left + this.visDimensions.margins.right).attr("height", this.visDimensions.height + this.visDimensions.margins.top + this.visDimensions.margins.bottom);
        this.body = this.baseVis.append("g").attr("transform", "translate(" + myVis.options.margins.left + "," + myVis.options.margins.top + ")");
        this.dataSet = this.body.append("g").attr("id", "dataSet-" + this.options.name);

        this.baseVis.append("g").attr("class", "xAxis-" + this.options.name).attr("transform", "translate(" + this.visDimensions.margins.left + "," + (this.visDimensions.height + this.visDimensions.margins.top) + ")").call(this.xAxis);
        this.baseVis.append("text").attr("x", this.visDimensions.width / 2).attr("y", this.visDimensions.height + (this.visDimensions.margins.top + this.visDimensions.margins.bottom) - 10).attr("text-anchor", "middle").attr("transform", "translate(" + this.visDimensions.margins.left + ",0)").text(this.options.xAxisLabel);
        this.baseVis.append("g").attr("class", "yAxis-" + this.options.name).attr("transform", "translate(" + this.visDimensions.margins.left + "," + this.visDimensions.margins.top + ")").call(this.yAxis);
        this.baseVis.append("text").attr("transform", "rotate(-90)").attr("y", 20).attr("x", 0 - (myVis.visDimensions.height / 2)).style("text-anchor", "middle").text(this.options.yAxisLabel);

        this.update();
        this.renderKey();
        $(this.options.visSelector).removeClass("vis-loading");
    };
    myVis.prototype.renderKey = function () {
        var myVis = this;
        var keyHeight = 30;
        var keyMargin = 5;
        var keyEntryHeight = keyHeight - keyMargin;
        var columns = [this.options.keySelector];

        if ($(this.options.keySelector2).length) {
            columns.push(this.options.keySelector2);
            if ($(this.options.keySelector3).length) {
                columns.push(this.options.keySelector3);
            }
        }

        var totalCategories = Object.keys(myVis.categories).length;
        var keyDimensions = { height: (Math.ceil(totalCategories / columns.length) * keyHeight), width: $(this.options.keySelector).width(), margins: this.options.keyMargins };
        var key;
        var keyGroup;

        for (var i = 0; i < columns.length; i++) {
            if (columns.hasOwnProperty(i)) {
                key = d3.select(columns[i]).append("svg").attr("width", keyDimensions.width).attr("height", keyDimensions.height + keyDimensions.margins.bottom + keyDimensions.margins.top);
                key = key.append("g").attr("transform", "translate(" + keyDimensions.margins.left + "," + keyDimensions.margins.top + ")");

                keyGroup = key.selectAll(".key-group").data(Object.keys(myVis.categories).slice(i * Math.ceil(totalCategories / columns.length), (i + 1) * Math.ceil(totalCategories / columns.length))).enter().append("g").attr("class", "key-group").attr("transform", function (d, i) { return "translate(0," + (i * keyHeight % keyDimensions.height) + ")"; });
                keyGroup.append("rect").attr("width", keyDimensions.width).attr("height", keyEntryHeight).attr("fill", function (d) { return myVis.color(d); }).attr("linegroup-block", function (d) { return d; });
                keyGroup.append("text").attr("class", "key-text").attr("dy", 18).attr("dx", 6).text(function (d) { return d; });
                keyGroup.append("rect").attr("width", keyDimensions.width).attr("height", keyEntryHeight).attr("linegroup", function (d) { return d; }).attr("columngroup", columns[i]).attr("opacity", 0)
                    .on('click', function () { return myVis.handleCategoryToggle(this); })
                    .on("mouseover", function () { return myVis.handleCategoryHover(this); })
                    .on("mouseout", function () { return myVis.handleCategoryHoverEnd(this); });
            }
        }
    };
    myVis.prototype.handleCategoryHover = function (element) {
        var lineGroup = d3.select(element).attr("linegroup");

        if (this.options.excludedCategories.indexOf(lineGroup) === -1) {
            this.body.selectAll("rect").attr("opacity", 0.1);
            this.body.selectAll("[fill='" + this.color(lineGroup) + "']").selectAll("rect").attr("opacity", 1);
        }
    };
    myVis.prototype.handleCategoryHoverEnd = function (element) {
        this.body.selectAll("rect").attr("opacity", 0.85);
    };
    myVis.prototype.handleCategoryToggle = function (element) {
        var lineGroup = d3.select(element).attr("linegroup");
        var columnGroup = d3.select(element).attr("columngroup");
        var index = this.options.excludedCategories.indexOf(lineGroup);
        var el = d3.select(columnGroup).selectAll("[linegroup-block='" + lineGroup + "']");

        if (index === -1) {
            el.attr("opacity", 0);
            this.options.excludedCategories.push(lineGroup);
        } else {
            el.attr("opacity", 1.0);
            this.options.excludedCategories.splice(index, 1);
        }

        this.update();
    };
    myVis.prototype.drawData = function () {
        var t = d3.transition().duration(1000).ease(d3.easeLinear);
        var myVis = this;

        if (!myVis.data) {
            myVis.visNoData.show();
            myVis.visContainer.hide();
        } else {
            myVis.visNoData.hide();
            myVis.visContainer.show();
        }

        var xMax = isNaN(this.options.age) ? d3.max(myVis.data, function (d) { return d.MonthsSinceFounding; }) + 1 : parseInt(this.options.age) + 1;
        var strokeWidth = app.page.isPageSmall() ? 0 : 1;
        var barWidth = (myVis.visDimensions.width / xMax) - (strokeWidth * 2);

        this.dataSet.selectAll("rect").transition(t).attr("height", 0).attr("y", myVis.yScale(0)).attr("x", myVis.xScale(xMax)).remove();
        this.dataSet.selectAll("*").transition(t).remove();


        myVis.data.sort(function (a, b) { return b.MonthsSinceFounding - a.MonthsSinceFounding; });

        this.baseVis.transition(t).select(".xAxis-" + this.options.name).call(myVis.xAxis);
        this.baseVis.transition(t).select(".yAxis-" + this.options.name).call(myVis.yAxis);

        myVis.dataSet.append("g")
            .selectAll("g")
            .data(d3.stack().keys(myVis.keys)(myVis.data))
            .enter().append("g")
            .attr("fill", function (d) { return myVis.color(d.key); })
            .attr("stroke-width", 1)
            .attr("stroke", function (d) { return d3.hsl(myVis.color(d.key)).darker(); })
            .attr("data-category", function (d) { return d.key; })
            .selectAll("rect")
            .data(function (d) { return d; })
            .enter().append("rect")
            .attr("x", myVis.xScale(0))
            .attr("y", myVis.yScale(0))
            .attr("width", barWidth)
            .on("mouseover",
                function (d, i) {
                    return myVis.showDetails(d, i, this);
                })
            .on("mouseout", $.proxy(myVis.hideDetails, this))
            .transition(t)
            .attr("x", function (d) { return myVis.xScale(d.data.MonthsSinceFounding) - (barWidth / 2); })
            .attr("y", function (d) { return isNaN(d[1]) ? 0 : myVis.yScale(d[1]); })
            .attr("height", function (d) { return isNaN(d[1]) ? 0 : myVis.yScale(d[0]) - myVis.yScale(d[1]); });
    };
    myVis.prototype.updateScales = function () {
        if (isNaN(this.options.age)) {
            this.xScale.domain([d3.max(this.data, function (d) { return d.MonthsSinceFounding; }) + 1, 0]).nice();
            this.xAxis.tickValues(d3.range(0, this.xScale.domain()[0], parseInt(this.xScale.domain()[0] / 11)));
        } else {
            this.xScale.domain([parseInt(this.options.age) + 1, 0]);
            this.xAxis.tickValues(d3.range(0, this.xScale.domain()[0], parseInt(this.xScale.domain()[0] / 6)));
        }

        this.yScale.domain([0, d3.max(this.data, function (d) { return d.Count; })]).nice();
    };

    return myVis;
}());
